module.exports = "img/frutos.655085.jpeg";